import { render } from "./VistaCurso.vue?vue&type=template&id=ce62efca&scoped=true"
import script from "./VistaCurso.vue?vue&type=script&lang=js"
export * from "./VistaCurso.vue?vue&type=script&lang=js"

import "./VistaCurso.vue?vue&type=style&index=0&id=ce62efca&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce62efca"]])

export default __exports__